<template>
  <router-view />
</template>
<script>
  export default {
    name: 'FluxoCaixaContaExtratoModule',
  }
</script>
